import formats from '../../api/formats'
import dialogs from '../common/dialogs.js'
import AssistClasses from '../assist/AssistClasses.js'
import people from './index.js'

class Strategy extends AssistClasses.Strategy {
  constructor (cxt) {
    super(cxt)
    this.citzenships = []
  }
  getTypeCode () {
    return 'INDIVIDUAL'
  }
  getTypeName () {
    return 'Физическое лицо'
  }
  setContext (cxt) {
    this.context = cxt
  }
  createModel () {
    var model = new Model()
    return model
  }
  createModelFromJSON (json) {
    return Object.assign(this.createModel(), JSON.parse(json))
  }
  createDefaultModel (individual) {
    return Object.assign(this.createModel(), {})
  }
  createModelFromData (data) {
    return Object.assign(this.createModel(), data)
  }
  updateSteps (scheme) {
    const ruleNameRu = (v) => !v || formats.isNameRu(v, 60) || 'Допустимы русские буквы'
    const innflRules = v => !v || formats.isInnfl(v) || 'Неверный формат ИНН'
    const snilsRules = v => !v || formats.isSnils(v) || 'Неверный формат СНИЛС'

    let steps = []

    new AssistClasses.Step(
      '',
      (step) => {},
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Фамилия',
            name: 'lastName',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Имя',
            name: 'firstName',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Отчество',
            name: 'middleName',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm8: true, xs8: true}
          },
          {
            fieldType: 'v-select',
            label: 'Пол',
            name: 'sex',
            itemText: 'text',
            itemValue: 'value',
            items: [
              {value: 'F', text: 'Жен.'},
              {value: 'M', text: 'Муж.'}
            ],
            grow: true,
            size: {sm4: true, xs4: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата рождения',
            name: 'birthday',
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-select',
            label: 'Гражданство',
            name: 'citizenship',
            itemText: 'value',
            itemValue: 'value',
            items: (model, field) => {
              return this.citzenships
            },
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'ИНН',
            name: 'innfl',
            rules: Array.of(innflRules),
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'СНИЛС',
            name: 'snils',
            rules: Array.of(snilsRules),
            grow: true,
            size: {sm6: true, xs6: true}
          }
        ]
      },
      {
      }).addToArray(steps)

    this.steps = steps
    this.citzenships = people.citizenships()
    return this
  }
  viewTitle (model) {
    return model['nameShort'] ? model['nameShort'] : this.getTypeName()
  }
  viewTitleComp (model) {
    return formats.createComp(`
      <span>${model['nameShort'] ? model['nameShort'] : this.getTypeName()}</span>
    `)
  }
  viewContentComp (model) {
    const _n = (name) => name ? name + ' ' : ''
    const _fname = (lastName, firstName, middleName) => {
      return ((lastName || firstName || middleName) && `${_n(lastName)}${_n(firstName)}${_n(middleName)}`) || '-'
    }
    return formats.createComp(`
      <div>
      <div><b> ${_fname(model['lastName'], model['firstName'], model['middleName'])}</b></div>
      <span>ИНН:<b> ${formats.isInnfl(model['innfl']) ? formats.formatInnfl(model['innfl']) : '-'} </b></span>
      <span>СНИЛС:<b> ${formats.isSnils(model['snils']) ? model['snils'] : '-'}</b></span>
      <div>Гражданство:<b> ${model['citizenship'] ? model['citizenship'] : '-'}</b></div>
      </div>`)
  }
  updateModel (model) {
    this.steps.forEach((step) => step.setModel(model))
  }
  fetchData (itemId) {
    return new Promise((resolve, reject) => {
      if (itemId) {
        people.getIndividual(itemId).then((individual) => {
          resolve(individual)
        })
      } else {
        resolve(null)
      }
    })
  }
  updateData (itemId, model) {
    let item = model
    console.log('updateData', model)
    return new Promise((resolve, reject) => {
      this.context.$store.dispatch('updatePeopleIndividual', {
        id: itemId,
        individual: {
          id: itemId,
          lastName: item.lastName,
          firstName: item.firstName,
          middleName: item.middleName,
          sex: item.sex,
          birthday: item.birthday,
          citizenship: item.citizenship,
          innfl: item.innfl,
          snils: item.snils
        }
      }).then(id => {
        resolve(id)
      })
    })
  }
  deleteData (itemId, model) {
    return new Promise((resolve, reject) => {
      dialogs.confirm(this.context,
        'Подтвердите',
        `Удалить запись о физ. лице?`,
          (self) => {
            self.$store.dispatch('deletePeopleIndividuals', {ids: [itemId]})
              .then(() => resolve())
          })
    })
  }
}

class Model {
  constructor () {
    this.modelType = '200.01'
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/people/Individual.js